/* Atelier Poilu — Taille par race / Size by breed, v4 (2026-09-09)
 * Le tableau de tailles vient du produit lui-même : metafield custom.tailles_structurees,
 * généré depuis custom.guide_des_tailles. Plus aucun tableau codé en dur, plus aucun
 * rapprochement approximatif par titre de produit.
 * Le bloc n'est rendu que si le metafield existe (voir snippets/ap-taille-par-race.liquid).
 * Quand plusieurs tailles conviennent (les guides font se toucher les bornes :
 * XS jusqu'a 3 kg, S a partir de 3 kg), on tranche sur l'ajustement combine
 * POIDS + TOUR DE POITRAIL, pas sur le poids seul.
 * Bilingue FR / EN : la langue vient de data-lang (request.locale.iso_code).
 * fr -> français, toute autre locale -> anglais.
 * Aucune dépendance externe. */
(function () {
  "use strict";

  /* Repères de race — indicatifs, côté CLIENTE uniquement.
     Les mesures du produit, elles, viennent du guide de la marque. */
  var BREEDS = {
    "Cocker":         { fr: "Cocker",         en: "Cocker Spaniel", poids: [11, 14.5], poitrail: [48, 58], cou: [33, 40] },
    "Teckel":         { fr: "Teckel",         en: "Dachshund",      poids: [7, 9.5],   poitrail: [37, 48], cou: [28, 36] },
    "Carlin":         { fr: "Carlin",         en: "Pug",            poids: [6, 9],     poitrail: [45, 58], cou: [30, 38] },
    "Cavalier":       { fr: "Cavalier",       en: "Cavalier",       poids: [5.5, 8],   poitrail: [40, 51], cou: [28, 35] },
    "Bouledogue fr.": { fr: "Bouledogue fr.", en: "French Bulldog", poids: [8, 14],    poitrail: [46, 62], cou: [33, 43] },
    "Chihuahua":      { fr: "Chihuahua",      en: "Chihuahua",      poids: [1.5, 3],   poitrail: [25, 34], cou: [18, 25] },
    "Yorkshire":      { fr: "Yorkshire",      en: "Yorkshire",      poids: [1.5, 3.5], poitrail: [26, 36], cou: [19, 26] },
    "Bichon":         { fr: "Bichon",         en: "Bichon Frise",   poids: [4, 7],     poitrail: [34, 46], cou: [24, 31] },
    "Shih Tzu":       { fr: "Shih Tzu",       en: "Shih Tzu",       poids: [4, 8],     poitrail: [38, 50], cou: [26, 33] }
  };

  /* Courbes générales poids -> mesure, utilisées quand le poids saisi sort de la
     fourchette habituelle de la race (chiot, chien mince, chien fort). */
  var CURVE = {
    poitrail: [[1.5,25],[2,29],[3,33],[4,37],[5,40],[6,43],[7,45],[8,47],[10,51],[12,54],[14,57],[16,60],[18,63],[20,66],[25,72],[30,78],[35,83]],
    cou:      [[1.5,18],[2,20],[3,23],[4,25],[5,27],[6,29],[7,31],[8,33],[10,35],[12,37],[14,39],[16,41],[18,43],[20,45],[25,49],[30,53],[35,56]]
  };

  var ORDRE = ["XXXS","XXS","XS","XS-S","S","S-M","M","M-L","L","L-XL","XL","XXL","2XL","3XL","4XL"];

  var I18N = {
    fr: {
      mesure:    { poids: "poids", poitrail: "tour de poitrail", cou: "tour de cou", dos: "longueur du dos" },
      titre:     "🐶 <strong>Pas sûr·e de la taille&nbsp;?</strong>",
      sous:      "Dites-nous la race et le poids de votre chien — on lit le guide de ce modèle pour vous.",
      poidsLbl:  "Poids (optionnel) : ",
      poidsPh:   "kg",
      defaut:    function (w) { return "(≈ " + w + " kg par défaut)"; },
      rassure:   "Un doute&nbsp;? <strong>Échange ou retour facile</strong> — écrivez-nous, on vérifie avec vous.",
      dosSeul:   function (t) { return t + " : ce modèle se choisit à la <strong>longueur du dos</strong>, qui ne se déduit pas de la race. Mesurez du collier à la base de la queue — le guide des tailles est juste en dessous, ou écrivez-nous."; },
      inconnu:   function (t) { return t + " : écrivez-nous, on vous confirme la taille de ce modèle en un message."; },
      trop_petit: function (t, s, m) { return t + " : plus fin que notre <strong>" + s + "</strong> (" + m + "). Écrivez-nous, on vérifie avant d'expédier."; },
      trop_grand: function (t, s, m) { return t + " : au-delà de notre <strong>" + s + "</strong> (" + m + "). Écrivez-nous, on vous conseille."; },
      entre:     function (t, a, b) { return t + " : entre <strong>" + a + "</strong> et <strong>" + b + "</strong> — par confort on conseille le <strong>" + b + "</strong>."; },
      desaccord: function (t, sp, sm, m, retenu, ecarte, ecartePlusGrand) { return t + " : le guide de la marque donne <strong>" + sp + "</strong> au poids et <strong>" + sm + "</strong> au " + m + " estimé. Tout bien pesé on conseille le <strong>" + retenu + "</strong> <span class='apoilu-alt'>(" + ecarte + (ecartePlusGrand ? " si votre chien est plutôt costaud" : " si votre chien est plutôt fin") + " — écrivez-nous, on vérifie)</span>"; },
      reco:      function (t, s) { return t + " : on recommande la taille <span class='apoilu-big'>" + s + "</span>."; },
      parPoids:  "d'après le poids indiqué dans le guide de ce modèle",
      parMesure: function (m, v) { return m + " estimé à " + v + " cm"; },
      large:     " (poids inhabituel pour la race — estimation large)",
      alt:       function (s) { return " · " + s + " possible selon la coupe."; },
      limiteCompare: function (x, y, m) { return " · cas limite avec le " + y + " : en comparant le poids ET le " + m + ", le " + x + " tombe plus juste."; },
      limiteConfort: function (x, y) { return " · à la limite avec le " + y + " ; par confort on conseille le " + x + "."; }
    },
    en: {
      mesure:    { poids: "weight", poitrail: "chest girth", cou: "neck girth", dos: "back length" },
      titre:     "🐶 <strong>Not sure about the size?</strong>",
      sous:      "Tell us your dog's breed and weight — we'll read this model's own size guide for you.",
      poidsLbl:  "Weight (optional): ",
      poidsPh:   "kg",
      defaut:    function (w) { return "(≈ " + w + " kg by default)"; },
      rassure:   "Not sure? <strong>Easy exchange or return</strong> — message us and we'll check with you.",
      dosSeul:   function (t) { return t + ": this model is chosen by <strong>back length</strong>, which can't be guessed from the breed. Measure from the collar to the base of the tail — the size guide is just below, or message us."; },
      inconnu:   function (t) { return t + ": message us and we'll confirm the right size for this model."; },
      trop_petit: function (t, s, m) { return t + ": slimmer than our <strong>" + s + "</strong> (" + m + "). Message us, we'll check before shipping."; },
      trop_grand: function (t, s, m) { return t + ": beyond our <strong>" + s + "</strong> (" + m + "). Message us and we'll advise."; },
      entre:     function (t, a, b) { return t + ": between <strong>" + a + "</strong> and <strong>" + b + "</strong> — for comfort we recommend <strong>" + b + "</strong>."; },
      desaccord: function (t, sp, sm, m, retenu, ecarte, ecartePlusGrand) { return t + ": the brand's guide gives <strong>" + sp + "</strong> by weight and <strong>" + sm + "</strong> by estimated " + m + ". On balance we recommend <strong>" + retenu + "</strong> <span class='apoilu-alt'>(" + ecarte + (ecartePlusGrand ? " if your dog is on the stocky side" : " if your dog is on the slim side") + " — message us and we'll check)</span>"; },
      reco:      function (t, s) { return t + ": we recommend size <span class='apoilu-big'>" + s + "</span>."; },
      parPoids:  "based on the weight range in this model's size guide",
      parMesure: function (m, v) { return "estimated " + m + ": " + v + " cm"; },
      large:     " (unusual weight for this breed — rough estimate)",
      alt:       function (s) { return " · " + s + " may also work depending on the cut."; },
      limiteCompare: function (x, y, m) { return " · borderline with " + y + ": comparing both weight AND " + m + ", " + x + " is the closer fit."; },
      limiteConfort: function (x, y) { return " · borderline with " + y + "; for comfort we recommend " + x + "."; }
    }
  };

  function rang(t) { var i = ORDRE.indexOf(t); return i < 0 ? 99 : i; }

  function interp(courbe, x) {
    if (x <= courbe[0][0]) return courbe[0][1];
    for (var i = 1; i < courbe.length; i++) {
      if (x <= courbe[i][0]) {
        var a = courbe[i - 1], b = courbe[i];
        return a[1] + (b[1] - a[1]) * (x - a[0]) / (b[0] - a[0]);
      }
    }
    return courbe[courbe.length - 1][1];
  }

  /* Estime une mesure à partir du poids. fiable=true si le poids reste dans la
     fourchette de la race (on interpole alors sur les repères de la race). */
  function estime(race, dim, w) {
    var r = race[dim], p = race.poids;
    if (r && w >= p[0] && w <= p[1]) {
      var t = (w - p[0]) / ((p[1] - p[0]) || 1);
      return { v: Math.round(r[0] + (r[1] - r[0]) * t), fiable: true };
    }
    return { v: Math.round(interp(CURVE[dim], w)), fiable: false };
  }

  function possede(tailles, dim) {
    for (var i = 0; i < tailles.length; i++) if (tailles[i][dim]) return true;
    return false;
  }

  /* Écart au centre d'une plage : 0 = pile au milieu, 1 = sur le bord, 2 = dehors.
     Sert à départager deux tailles qui « contiennent » toutes les deux la valeur —
     cas très fréquent, les guides faisant se toucher les bornes (XS jusqu'à 3 kg,
     S à partir de 3 kg). */
  function ecart(r, v) {
    var c = (r[0] + r[1]) / 2, demi = (r[1] - r[0]) / 2;
    if (demi <= 0) return (v === r[0]) ? 0 : 2;
    return Math.min(Math.abs(v - c) / demi, 2);
  }

  /* Qualité d'ajustement d'une taille, moyennée sur TOUTES les mesures connues
     (poids ET tour de poitrail / de cou), pas seulement celle qui a servi à filtrer. */
  function ajustement(taille, mesures) {
    var somme = 0, n = 0;
    for (var i = 0; i < mesures.length; i++) {
      var r = taille[mesures[i].dim];
      if (!r) continue;
      somme += ecart(r, mesures[i].v); n++;
    }
    return n ? { score: somme / n, dims: n } : null;
  }

  function trouver(tailles, t) {
    for (var i = 0; i < tailles.length; i++) if (tailles[i].t === t) return tailles[i];
    return null;
  }

  /* Choisit une taille pour une valeur donnée sur une dimension donnée.
     `mesures` sert à départager quand plusieurs tailles conviennent. */
  function choisir(tailles, dim, valeur, mesures) {
    var avec = [], hits = [], i;
    for (i = 0; i < tailles.length; i++) if (tailles[i][dim]) avec.push(tailles[i]);
    if (!avec.length) return null;
    for (i = 0; i < avec.length; i++) {
      var r = avec[i][dim];
      if (valeur >= r[0] && valeur <= r[1]) hits.push(avec[i]);
    }
    if (hits.length === 1) return { taille: hits[0].t, alt: null };
    if (hits.length > 1) {
      var classe = [], a;
      for (i = 0; i < hits.length; i++) {
        a = ajustement(hits[i], mesures || []);
        classe.push({ t: hits[i].t, s: a ? a.score : 1, dims: a ? a.dims : 0 });
      }
      /* meilleur ajustement d'abord ; à égalité, la plus grande taille (confort) */
      classe.sort(function (x, y) { return (x.s - y.s) || (rang(y.t) - rang(x.t)); });
      return {
        taille: classe[0].t,
        alt: classe[1].t,
        limite: (classe[1].s - classe[0].s) < 0.2,
        dims: classe[0].dims
      };
    }
    if (valeur < avec[0][dim][0]) return { sous: avec[0].t };
    if (valeur > avec[avec.length - 1][dim][1]) return { sur: avec[avec.length - 1].t };
    var bas = null, haut = null;
    for (i = 0; i < avec.length; i++) {
      if (avec[i][dim][1] < valeur) bas = avec[i].t;
      if (avec[i][dim][0] > valeur && !haut) haut = avec[i].t;
    }
    return { entre: [bas, haut] };
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function lireDonnees(root) {
    var s = root.querySelector("script.apoilu-data");
    if (!s) return null;
    try {
      var d = JSON.parse(s.textContent);
      if (!d || !d.tailles || !d.tailles.length) return null;
      d.tailles.sort(function (a, b) { return rang(a.t) - rang(b.t); });
      return d;
    } catch (e) { return null; }
  }

  function init(root) {
    var data = lireDonnees(root);
    if (!data) { root.style.display = "none"; return; }

    var iso = (root.getAttribute("data-lang") || "fr").toLowerCase().slice(0, 2);
    var lang = (iso === "fr") ? "fr" : "en";
    var T = I18N[lang];

    var tailles = data.tailles;
    var aPoids = possede(tailles, "poids");
    var aPoitrail = possede(tailles, "poitrail");
    var aCou = possede(tailles, "cou");
    var aDos = possede(tailles, "dos");

    root.innerHTML = "";
    root.appendChild(el("div", "apoilu-head", T.titre));
    root.appendChild(el("div", "apoilu-sub", T.sous));

    var chips = el("div", "apoilu-chips");
    Object.keys(BREEDS).forEach(function (cle) {
      var b = el("button", "apoilu-chip", BREEDS[cle][lang] || cle);
      b.type = "button";
      b.setAttribute("data-b", cle);
      chips.appendChild(b);
    });
    root.appendChild(chips);

    var wrow = el("div", "apoilu-wrow", T.poidsLbl);
    var wt = el("input");
    wt.type = "number"; wt.min = "1"; wt.max = "60"; wt.step = "0.5";
    wt.placeholder = T.poidsPh; wt.className = "apoilu-wt";
    var whint = el("span", "apoilu-whint", "");
    wrow.appendChild(wt); wrow.appendChild(whint);
    root.appendChild(wrow);

    var res = el("div", "apoilu-res");
    res.style.display = "none";
    root.appendChild(res);

    /* La note libre du guide ("cette marque taille grand"…) est en français :
       on ne l'affiche que sur la locale française. */
    if (data.note && lang === "fr") root.appendChild(el("div", "apoilu-reassure", data.note));
    root.appendChild(el("div", "apoilu-reassure", T.rassure));

    var courante = null;

    function afficher() {
      if (!courante) { res.style.display = "none"; return; }
      var race = BREEDS[courante];
      var saisi = parseFloat(wt.value);
      var w = (saisi > 0) ? saisi : (race.poids[0] + race.poids[1]) / 2;
      var wAff = Math.round(w * 10) / 10;
      whint.textContent = (saisi > 0) ? "" : T.defaut(wAff);
      res.style.display = "block";

      /* Mesure de coupe : poitrail sinon cou, estimé depuis le poids. */
      var dimMesure = aPoitrail ? "poitrail" : (aCou ? "cou" : null);
      var est = dimMesure ? estime(race, dimMesure, w) : null;

      /* Toutes les mesures dont on dispose — elles servent à départager. */
      var mesures = [];
      if (aPoids) mesures.push({ dim: "poids", v: w });
      if (est) mesures.push({ dim: dimMesure, v: est.v });

      /* 1. Le poids donné par la marque prime : c'est une donnée, pas une estimation. */
      var parPoids = aPoids ? choisir(tailles, "poids", w, mesures) : null;
      /* 2. Repli sur la mesure de coupe. */
      var parMesure = dimMesure ? choisir(tailles, dimMesure, est.v, mesures) : null;

      var tete = (race[lang] || courante) + " (~" + wAff + " kg)";

      if (!parPoids && !parMesure) {
        res.className = "apoilu-res info";
        res.innerHTML = aDos ? T.dosSeul(tete) : T.inconnu(tete);
        surligner(null);
        return;
      }

      var principal = parPoids || parMesure;
      var dimPrincipale = parPoids ? "poids" : dimMesure;

      /* Hors plage : on le dit, on ne force pas une taille. */
      if (principal.sous) {
        res.className = "apoilu-res info";
        res.innerHTML = T.trop_petit(tete, principal.sous, T.mesure[dimPrincipale]);
        surligner(null); return;
      }
      if (principal.sur) {
        res.className = "apoilu-res info";
        res.innerHTML = T.trop_grand(tete, principal.sur, T.mesure[dimPrincipale]);
        surligner(null); return;
      }
      if (principal.entre) {
        var haut = principal.entre[1] || principal.entre[0];
        res.className = "apoilu-res warn";
        res.innerHTML = T.entre(tete, principal.entre[0], principal.entre[1]);
        surligner(haut); return;
      }

      /* Recoupement poids / mesure quand les deux existent et ne donnent pas la
         même taille : on tranche sur l'ajustement combiné, pas sur le poids seul. */
      if (parPoids && parMesure && parMesure.taille && parMesure.taille !== parPoids.taille) {
        var aP = ajustement(trouver(tailles, parPoids.taille), mesures);
        var aM = ajustement(trouver(tailles, parMesure.taille), mesures);
        var sP = aP ? aP.score : 1, sM = aM ? aM.score : 1;
        var retenu;
        if (Math.abs(sP - sM) < 0.15) {
          /* ex aequo : par confort, la plus grande */
          retenu = (rang(parPoids.taille) >= rang(parMesure.taille)) ? parPoids.taille : parMesure.taille;
        } else {
          retenu = (sP < sM) ? parPoids.taille : parMesure.taille;
        }
        var ecarte = (retenu === parPoids.taille) ? parMesure.taille : parPoids.taille;
        res.className = "apoilu-res warn";
        res.innerHTML = T.desaccord(tete, parPoids.taille, parMesure.taille, T.mesure[dimMesure],
                                    retenu, ecarte, rang(ecarte) > rang(retenu));
        surligner(retenu); return;
      }

      var taille = principal.taille;
      var detail = parPoids
        ? T.parPoids
        : (T.parMesure(T.mesure[dimMesure], est.v) + (est.fiable ? "" : T.large));

      /* Cas limite : deux tailles se valaient presque (bornes qui se touchent). */
      var suffixe = "";
      if (principal.alt && principal.limite) {
        suffixe = (principal.dims >= 2 && dimMesure)
          ? T.limiteCompare(taille, principal.alt, T.mesure[dimMesure])
          : T.limiteConfort(taille, principal.alt);
      } else if (principal.alt) {
        suffixe = T.alt(principal.alt);
      }

      res.className = "apoilu-res ok";
      res.innerHTML = T.reco(tete, taille)
        + "<span class='apoilu-alt'>" + detail + suffixe + "</span>";
      surligner(taille);
    }

    /* Surligne le bouton de variante correspondant. On s'accroche à la valeur du
       radio, pas au texte du label : le label contient aussi « Variante épuisée
       ou indisponible » en texte masqué, ce qui faisait échouer toute comparaison. */
    function surligner(taille) {
      try {
        var portee = root.closest("product-info") || document;
        var anciens = portee.querySelectorAll(".apoilu-hl");
        for (var i = 0; i < anciens.length; i++) anciens[i].classList.remove("apoilu-hl");
        if (!taille) return;
        var cible = taille.toUpperCase().replace(/\s/g, "");
        var radios = portee.querySelectorAll("input[type=radio]");
        for (var j = 0; j < radios.length; j++) {
          var v = (radios[j].value || "").trim().toUpperCase().replace(/\s/g, "");
          if (v !== cible) continue;
          var lab = null;
          if (radios[j].id) lab = portee.querySelector('label[for="' + radios[j].id + '"]');
          if (!lab) lab = radios[j].closest("label");
          if (!lab) lab = radios[j].nextElementSibling;
          if (lab && lab.classList) lab.classList.add("apoilu-hl");
        }
      } catch (e) {}
    }

    chips.addEventListener("click", function (e) {
      var btn = e.target.closest(".apoilu-chip");
      if (!btn) return;
      var tous = chips.querySelectorAll(".apoilu-chip");
      for (var i = 0; i < tous.length; i++) tous[i].classList.remove("on");
      btn.classList.add("on");
      courante = btn.getAttribute("data-b");
      afficher();
    });
    wt.addEventListener("input", afficher);
  }

  function boot() {
    var blocs = document.querySelectorAll(".apoilu-taille");
    for (var i = 0; i < blocs.length; i++) init(blocs[i]);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
